import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';

const TseuModal = ({ showTseuModal, handleTseuModalToggleOff }) => (
  <Modal show={showTseuModal} onHide={handleTseuModalToggleOff}>
    <Modal.Header closeButton id="options-modal-title">
      <h1 id="page-header" className="h1_secondary">
        About Joint Accounts
      </h1>
    </Modal.Header>
    <Modal.Body className="options-submit-modal-body">
      <div>
        <p>
          A joint investment account can be opened by two individuals. Both account holders
          have equal rights and can independently make changes or place orders on the
          account. The account holders are jointly and severally liable for all obligations
          arising from the account. In the event of death, the deceased account holder&apos;s
          share will pass to his or her heirs, not automatically to the surviving account
          holder. In cases of divorce or other dispute, the account holders themselves are
          responsible for agreeing on the division of the account balance. TradeStation
          Europe B.V. does not accept any liability for disputes between account holders.
        </p>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <div className="text-center">
        <button
          id="ok_btn"
          onClick={handleTseuModalToggleOff}
          className="btn btn-raised btn-default btn-equities-modal do_capitalize"
        >
          Close
        </button>
      </div>
    </Modal.Footer>
  </Modal>
);

TseuModal.propTypes = {
  showTseuModal: PropTypes.bool,
  handleTseuModalToggleOff: PropTypes.func,
};

export default TseuModal;
